import { Fragment, useEffect, useState } from "react";
import { TopBar } from "../../../widgets";
import { NavigateLogin, DividerThin, PaidHistoryCard } from "../../../shared";
import { isLogin } from "../../../utils";
import MyTrainingHistorySkeleton from "../../../components/skeleton/my/myTrainingHistorySkeleton";
import { useNavigate, useParams } from "react-router-dom";
import { getAllPaidHistoryByMemberIdV3 as getAllPaidHistoryByMemberIdV3 } from "../../../service/paidHistory";
import { Button } from "antd";

const PaidHistory = () => {
    const navigate = useNavigate();
    const [paidHistoryList, setPaidHistoryList] = useState<IPaidHistoryV3[]>([]);
    const { memberId } = useParams();
    const [isInitLoading, setIsInitLoading] = useState<boolean>(true);
    useEffect(() => {
        if (!memberId) return;
        getAllPaidHistoryByMemberIdV3(memberId)
            .then((res) => setPaidHistoryList(res.data))
            .catch((error) => console.error("error", error))
            .finally(() => setIsInitLoading(false))
    }, [memberId])

    return <>
        {isInitLoading && <MyTrainingHistorySkeleton />}
        {!isLogin()
            ? <>
                <TopBar title="구매 내역" rightIcon={false} position='fixed' thema='dark' />
                <NavigateLogin />
            </>
            : <>
                <TopBar title="구매 내역" rightIcon={false} position='fixed' thema='dark' />
                <div style={{ padding: 'var(--space32) var(--space20)' }}>
                    <div>
                        {paidHistoryList?.length <= 0
                            ? <div style={{ marginTop: 250, textAlign: 'center' }}>
                                <div className="body/b2 secondary/s800">확정된 프로그램이 없습니다.</div>
                                <div style={{ marginTop: 8 }}>
                                    <Button color="default" variant="outlined" onClick={() => navigate('/explore')}> 프로그램 둘러보기</Button>
                                </div>
                            </div>
                            : paidHistoryList.map((paidHistory, idx) => <Fragment key={idx}>
                                <PaidHistoryCard paidHistory={paidHistory} />
                                {paidHistoryList.length - 1 !== idx && <DividerThin style={{ marginBlock: 'var(--space20)' }} />}
                            </Fragment>)}

                    </div>
                </div>
            </>}
    </>
}

export { PaidHistory }